import { Sagas as Assets } from 'sections/assets';
import { Sagas as Campaigns } from 'sections/campaigns';
import { Sagas as Clients } from 'sections/client-management';
import { Sagas as Auth } from '../services/authentication';
import { Sagas as ConsentImportJobsByBrand } from '../services/consentImportJobs/byBrand';
import { Sagas as ConsentImportJobsBySite } from '../services/consentImportJobs/bySite';
import { Sagas as IPBlacklist } from '../services/ipBlacklist';
import { Sagas as Users } from '../services/users';
import { Sagas as Watches } from '../services/watches';
import { notificationBarSaga } from '../core/ui/notificationBar';

const Sagas = [
  ...Assets,
  ...Auth,
  ...Campaigns,
  ...Clients,
  ...ConsentImportJobsByBrand,
  ...ConsentImportJobsBySite,
  ...IPBlacklist,
  ...Users,
  ...Watches,
  notificationBarSaga,
];

export default Sagas;
